import store from 'store';
import { SelectOption } from 'modules/Campaigns/interfaces';
import { IAssetDropdownItem, IGraphData, ISearchedEmailDropdownList } from '../interfaces';
import { ANALYTICS_DEFAULT_DATES_FILTER } from '../Contacts/utils';
import { getMonthDates, getQuarterDates, getDateObject, getAllTimeDates } from 'utils';
import { storeLoading } from 'modules/Campaigns/AssetsWithOutCampaigns/actions';
import { applyFiltersFromLocalStorage, moveSelectedFiltersToApplied } from 'modules/Analytics/actions';
import {
  ANALYTICS_ASSETS_SEARCH,
  ANALYTICS_CAMPAIGNS_SEARCH,
  ANALYTICS_CARD_DATA,
  ANALYTICS_DASHBOARD,
  ANALYTICS_DASHBOARD_GRAPH_DATA,
  ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS,
  ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS,
  ANALYTICS_DATA_EXPORT,
  ANALYTICS_INTENT_DATA,
  GET_ANALYTICS_ASSETS_FILTERS,
  GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST,
  GET_ANALYTICS_CAMPAIGNS_FILTERS,
  GET_ANALYTICS_WORKFLOW_FILTERS,
  ANALYTICS_WORKFLOWS_SEARCH,
  GET_ANALYTICS_WORKFLOW_LIST,
  ANALYTICS_DASHBOARD_WORKFLOW,
  ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS,
  GET_ANALYTICS_FILTERS_DROPDOWN_DATA,
} from 'constants/types';
import {
  getAnalyticsFilterId,
  getQueryAllCampaigns,
  getQueryCampaignId,
  getQueryEmailId,
  getQueryEmailIds,
  getQueryIsAIEmail,
  getQueryWorkflowId,
} from 'modules/EmailBrowser/utils';
import {
  analyticsDashboardService,
  analyticsOverviewService,
  getAnalyticsCampaignsAssetsListService,
  getAnalyticsWorkflowListService,
  getAnalyticsGraphDataService,
  getAnalyticsSelectedCampaignsAssetsListService,
  getCampaignAndWorkflowDropdownService,
  getEmailDropdownService,
  getAnalyticsEmailGraphDataService,
  getAnalyticsCampaignGraphDataService,
} from 'modules/Services/AnalyticsService';
import {
  resetAllTabsFilter,
  serializeAnalyticsCampaigns,
  serializeAnalyticsEmails,
  getConstantCampaignEmailId,
  serializeAnalyticsWorkflow,
  serializeAnalyticsFiltersDropdownCampaigns,
  serializeDropdownEmails,
  emailGraphKpis,
} from '../utils';

export const setFirstTimeAllDataShown = (flag: boolean) => {
  store.dispatch({
    type: ANALYTICS_CARD_DATA.SET_FIRST_ALL_DATA_SHOWN,
    payload: flag,
  });
};

export const getAnalyticsCardData = (params: any = {}) => {
  if (!params.exportAnalytics) storeLoading(ANALYTICS_CARD_DATA.LOAD);

  if (
    (params.startDate === undefined || params.startDate === '') &&
    (params.endDate === undefined || params.endDate === '')
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange(ANALYTICS_DEFAULT_DATES_FILTER);
    if (ANALYTICS_DEFAULT_DATES_FILTER.value === 'qtr') {
      startDate = getQuarterDates().start_date;
      endDate = getQuarterDates().end_date;
    } else if (ANALYTICS_DEFAULT_DATES_FILTER.value === 'month') {
      startDate = getMonthDates().start_date;
      endDate = getMonthDates().end_date;
    }
    params['startDate'] = startDate;
    params['endDate'] = endDate;
  }
  const queryWorkflowId = getQueryWorkflowId();
  const isWorkflow = !!queryWorkflowId || store.getState().analyticsDashboard.isWorkflow;
  params.isWorkflow = isWorkflow;
  analyticsOverviewService(params)
    .then((response) => {
      if (response?.data?.success) {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: response.data.email_address,
          });
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: false,
          });
        } else {
          store.dispatch({
            type: ANALYTICS_CARD_DATA.SUCCESS,
            payload: { ...response.data },
          });
          // check if every element in the object is 0
          const isEmpty = Object.keys(response.data.stats).every((key) => response.data.stats[key] === 0);
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: isEmpty ? true : false,
          });
        }
        setFirstTimeAllDataShown(true);
      } else {
        store.dispatch({
          type: ANALYTICS_CARD_DATA.FAIL,
        });
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: true,
        });
      }
    })
    .catch((err) => {
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_CARD_DATA.FAIL,
        });
      }
      store.dispatch({
        type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
        payload: true,
      });
    });
};
export const getAnalyticsContentData = (params: any = {}, callback?: any) => {
  storeLoading(ANALYTICS_INTENT_DATA.LOAD);

  if (
    (params.startDate === undefined || params.startDate === '') &&
    (params.endDate === undefined || params.endDate === '')
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange(ANALYTICS_DEFAULT_DATES_FILTER);
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    params['startDate'] = startDate;
    params['endDate'] = endDate;
  }
  const queryWorkflowId = getQueryWorkflowId();
  const isWorkflow = !!queryWorkflowId || store.getState().analyticsDashboard.isWorkflow;
  params.isWorkflow = isWorkflow;
  analyticsDashboardService(params)
    .then((response) => {
      if (response?.data?.success) {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.SUCCESS,
          payload: { ...response.data },
        });
      } else {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.FAIL,
        });
      }
      if (callback)
        setTimeout(() => {
          callback(true);
        }, 500);
      store.dispatch({ type: ANALYTICS_CARD_DATA.FILTER_RESET, payload: false });
    })
    .catch((err) => {
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.FAIL,
        });
      }
    });
};

export const resetAnalyticsGraphData = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.CLEAR,
  });
};

export const getAnalyticsCampaignsAssetsList = (allCampaigns?: boolean, useLocalStorageData?: boolean) => {
  getAnalyticsCampaignsAssetsListService()
    .then((response) => {
      if (response.data) {
        let { email_data, campaign_data, total_campaigns, total_emails, workflows: workflow_data } = response.data;
        let assets = serializeAnalyticsEmails(email_data);
        let campaigns = serializeAnalyticsCampaigns(campaign_data);
        let workflows = serializeAnalyticsWorkflow(workflow_data);
        store.dispatch({
          type: GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.SUCCESS,
          payload: { assets, campaigns, total_campaigns, total_emails, allCampaigns: allCampaigns },
        });
        store.dispatch({ type: ANALYTICS_CARD_DATA.RENDER_DONE, payload: true });
        store.dispatch({ type: GET_ANALYTICS_WORKFLOW_LIST.SUCCESS, payload: workflows });
        const campaignId = getQueryCampaignId();
        const emailId = getQueryEmailId();
        const allCampaign = getQueryAllCampaigns();
        const fsId = getAnalyticsFilterId();
        if (campaignId && emailId) {
          let campaignAssets = assets.filter((asset) => asset.campaignId === campaignId);
          let filteredAsset = assets.find((asset) => asset.id === emailId);
          if (filteredAsset) {
            if (!allCampaigns) {
              updateFilterAssetList(campaignAssets); // added this action because some of the emails have no analytics
            }
          }
        }
        if (campaignId && !emailId && !fsId) {
          selectCampaign(campaignId);
          moveSelectedFiltersToApplied();
        }
        if (allCampaign === 'true') {
          selectAllCampaigns();
          moveSelectedFiltersToApplied();
        }
        reorderCampaignsAndEmails();
        reorderWorkflows();
        if (useLocalStorageData) {
          applyFiltersFromLocalStorage(JSON.parse(localStorage.getItem('analyticsFiltersWithId') || ''));
        }
      }
    })
    .catch((err) => {
      console.log('Analytics Error: ', err);
      store.dispatch({ type: ANALYTICS_CARD_DATA.RENDER_DONE, payload: true });
    });
};
export const getAnalyticsSelectedCampaignsAssetsList = (campaignIds: string | any[] | undefined = []) => {
  getAnalyticsSelectedCampaignsAssetsListService(campaignIds)
    .then((response) => {
      if (response.data) {
        let { email_data } = response.data;
        let assets = serializeAnalyticsEmails(email_data);
        store.dispatch({
          type: GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.FILTER_EMAILS,
          payload: { assets: assets, campaignIds: campaignIds, campaign_id: campaignIds[campaignIds.length - 1] },
        });
      }
    })
    .catch((err) => {
      console.log('Analytics Error: ', err);
    });
};

export const setIsWorkflow = (flag: boolean) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_WORKFLOW.FIRST_TIME_SET,
    payload: flag,
  });
};

export const loadingAnalyticsWorkflowList = () => {
  store.dispatch({
    type: GET_ANALYTICS_WORKFLOW_LIST.LOAD,
  });
};

export const getAnalyticsWorkflowList = () => {
  loadingAnalyticsWorkflowList();
  getAnalyticsWorkflowListService()
    .then((response) => {
      if (response.data.success) {
        store.dispatch({
          type: GET_ANALYTICS_WORKFLOW_LIST.SUCCESS,
          payload: response.data,
        });
        let selectedWfIds = store.getState().analyticsDashboard.selectedWorkflowIds;
        if (selectedWfIds.length > 0) store.dispatch({ type: GET_ANALYTICS_WORKFLOW_LIST.REORDER });
      }
    })
    .catch((err) => {
      console.log('Analytics Error: ', err);
    });
};

export const getGraphData = (params?: any, callback?: any) => {
  let additionalParams: any = {
    analytic_request: '1',
    allCampaigns: params.allCampaigns,
    selectAll: params.selectAll,
    unSelectAll: params.unSelectAll,
    searchedEmailList: params?.searchedEmailList ?? [],
    emailIds: params?.emailIds ?? [],
    excludeAssetsIds: params?.excludeAssetsIds ?? [],
  };
  // updating check if user have campaign id it will add in payload
  if (
    (params.campaignIds !== undefined && params.campaignIds.length > 0) ||
    (params.emailIds !== undefined && params.emailIds.length > 0)
  ) {
    additionalParams = {
      ...additionalParams,
      campaignIds: params.campaignIds,
    };
  }
  if (params?.workflowIds?.length > 0) {
    additionalParams = {
      ...additionalParams,
      workflowIds: params.workflowIds,
    };
  }
  if (
    (params.startDate === undefined || params.startDate === '') &&
    (params.endDate === undefined || params.endDate === '')
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange({ value: 'qtr', label: '1 QTR' });
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    additionalParams['startDate'] = startDate;
    additionalParams['endDate'] = endDate;
  } else {
    additionalParams['startDate'] = params.startDate;
    additionalParams['endDate'] = params.endDate;
  }

  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  const queryWorkflowId = getQueryWorkflowId();
  const isWorkflow = !!queryWorkflowId || store.getState().analyticsDashboard.isWorkflow;
  additionalParams.isWorkflow = isWorkflow;
  getAnalyticsGraphDataService(additionalParams)
    .then((res: any) => {
      const serializedData: IGraphData = res.data;
      store.dispatch({
        type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_SUCCESS,
        payload: serializedData,
      });
    })
    .catch((err: any) => {
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_FAIL,
          payload: {},
        });
      }
      // show error alert on frontend
    });
};

export const getEmailGraphData = (params: any) => {
  let additionalParams: any = {
    analytic_request: '1',
    allCampaigns: params.allCampaigns,
    selectAll: params.selectAll,
    unSelectAll: params.unSelectAll,
    searchedEmailList: params?.searchedEmailList ?? [],
    emailIds: params?.emailIds ?? [],
    excludeAssetsIds: params?.excludeAssetsIds ?? [],
  };
  // updating check if user have campaign id it will add in payload
  if (
    (params.campaignIds !== undefined && params.campaignIds.length > 0) ||
    (params.emailIds !== undefined && params.emailIds.length > 0)
  ) {
    additionalParams = {
      ...additionalParams,
      campaignIds: params.campaignIds,
    };
  }
  if (params?.workflowIds?.length > 0) {
    additionalParams = {
      ...additionalParams,
      workflowIds: params.workflowIds,
    };
  }
  if (
    (params.startDate === undefined || params.startDate === '') &&
    (params.endDate === undefined || params.endDate === '')
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange({ value: 'qtr', label: '1 QTR' });
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    additionalParams['startDate'] = startDate;
    additionalParams['endDate'] = endDate;
  } else {
    additionalParams['startDate'] = params.startDate;
    additionalParams['endDate'] = params.endDate;
  }

  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.EMAIL_LOAD,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  store.dispatch({ type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_EMAIL_GRAPH_DATA_FILTERED, payload: [] });
  getAnalyticsEmailGraphDataService(additionalParams)
    .then((res: any) => {
      const data: any[] = res.data.data;
      const newArray: any[] = data.map((item) => ({
        ...((!!item.total_bounced ||
          !!item.total_clicks ||
          !!item.total_opens ||
          !!item.total_unsubscribed ||
          !!item.unique_clicks ||
          !!item.unique_opens) && { date: item.date_time }),
        ...(!!item.total_bounced && { totalBounced: item.total_bounced }),
        ...(!!item.total_clicks && { totalClicks: item.total_clicks }),
        ...(!!item.total_opens && { totalOpens: item.total_opens }),
        ...(!!item.total_unsubscribed && { totalUnsubscribed: item.total_unsubscribed }),
        ...(!!item.unique_clicks && { uniqueClicks: item.unique_clicks }),
        ...(!!item.unique_opens && { uniqueOpens: item.unique_opens }),
      }));

      store.dispatch({
        type: ANALYTICS_DASHBOARD_GRAPH_DATA.EMAIL_LOAD_SUCCESS,
        payload: newArray,
      });
      const emailGraphFilter = store.getState().analyticsGraph.emailGraphFilter;

      const filteredData = newArray.map((data) => {
        let newData: any = { date: data.date };

        if (emailGraphFilter.includes(emailGraphKpis.bounced) && !!data.totalBounced) {
          newData = { ...newData, totalBounced: data.totalBounced };
        }
        if (emailGraphFilter.includes(emailGraphKpis.totalClicks) && !!data.totalClicks) {
          newData = { ...newData, totalClicks: data.totalClicks };
        }
        if (emailGraphFilter.includes(emailGraphKpis.totalOpens) && !!data.totalOpens) {
          newData = { ...newData, totalOpens: data.totalOpens };
        }
        if (emailGraphFilter.includes(emailGraphKpis.unsubscribed) && !!data.totalUnsubscribed) {
          newData = { ...newData, totalUnsubscribed: data.totalUnsubscribed };
        }
        if (emailGraphFilter.includes(emailGraphKpis.uniqueClicks) && !!data.uniqueClicks) {
          newData = { ...newData, uniqueClicks: data.uniqueClicks };
        }
        if (emailGraphFilter.includes(emailGraphKpis.uniqueOpens) && !!data.uniqueOpens) {
          newData = { ...newData, uniqueOpens: data.uniqueOpens };
        }
        return newData;
      });
      store.dispatch({ type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_EMAIL_GRAPH_DATA_FILTERED, payload: filteredData });
    })
    .catch((err: any) => {
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_DASHBOARD_GRAPH_DATA.EMAIL_RESET,
        });
      }
      // show error alert on frontend
    });
};

export const getCampaignGraphData = (params: any) => {
  let additionalParams: any = {
    analytic_request: '1',
    allCampaigns: params.allCampaigns,
    selectAll: params.selectAll,
    unSelectAll: params.unSelectAll,
    searchedEmailList: params?.searchedEmailList ?? [],
    emailIds: params?.emailIds ?? [],
    excludeAssetsIds: params?.excludeAssetsIds ?? [],
  };
  // updating check if user have campaign id it will add in payload
  if (
    (params.campaignIds !== undefined && params.campaignIds.length > 0) ||
    (params.emailIds !== undefined && params.emailIds.length > 0)
  ) {
    additionalParams = {
      ...additionalParams,
      campaignIds: params.campaignIds,
    };
  }
  if (params?.workflowIds?.length > 0) {
    additionalParams = {
      ...additionalParams,
      workflowIds: params.workflowIds,
    };
  }
  if (
    (params.startDate === undefined || params.startDate === '') &&
    (params.endDate === undefined || params.endDate === '')
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange({ value: 'qtr', label: '1 QTR' });
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    additionalParams['startDate'] = startDate;
    additionalParams['endDate'] = endDate;
  } else {
    additionalParams['startDate'] = params.startDate;
    additionalParams['endDate'] = params.endDate;
  }

  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.CAMPAIGN_LOAD,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.CAMPAIGN_COUNT_SET,
    payload: 0,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  getAnalyticsCampaignGraphDataService(additionalParams)
    .then((res: any) => {
      const { events, campaign_count } = res.data.data;
      const graphData = Object.keys(events).map((item) => ({ date: item, campaignsData: events[item] }));

      store.dispatch({
        type: ANALYTICS_DASHBOARD_GRAPH_DATA.CAMPAIGN_LOAD_SUCCESS,
        payload: graphData,
      });
      store.dispatch({
        type: ANALYTICS_DASHBOARD_GRAPH_DATA.CAMPAIGN_COUNT_SET,
        payload: campaign_count,
      });
    })
    .catch((err: any) => {
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_DASHBOARD_GRAPH_DATA.CAMPAIGN_RESET,
        });
      }
      // show error alert on frontend
    });
};

export const setEmailGraphFilter = (val: Array<string>) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_EMAIL_GRAPH_FILTER,
    payload: val,
  });
};

export const setCampaignGraphFilter = (val: { value: string; label: string }) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_CAMPAIGN_GRAPH_FILTER,
    payload: val,
  });
};

export const setEmailGraphFilteredData = (val: any[]) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_EMAIL_GRAPH_DATA_FILTERED,
    payload: val,
  });
};

export const setCampaignsFilter = (filter: any, noReset?: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_FILTERS,
    payload: filter,
  });
  if (!noReset) {
    if (filter.isAllCampaigns !== undefined) resetAllTabsFilter(true);
  }
};

export const resetAllTabsSelectedCampaignsAndEmailsAndGetList = () => {
  resetAllTabsFilter(true);
  resetSelectedCampaigns();
  resetSelectedEmails();
};

export const setShareProfileFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_SHARE_PROFILE_FILTER,
    payload: flag,
  });
  resetAllTabsFilter(true);
  resetSelectedCampaigns();
  // resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const setDailyIqFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_DAILY_IQ_FILTER,
    payload: flag,
  });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const setWeeklyAccountInsightsFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_WEEKLY_ACCOUNTS_INSIGHTS_FILTER,
    payload: flag,
  });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const toggleWorkflowFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_WORKFLOW_FILTER,
    payload: flag,
  });
  // commenting this becuase we are reseting emails in AssetFiltersDropdown
  // resetAllTabsSelectedCampaignsAndEmailsAndGetList();
  if (flag === false) {
    resetSelectedWorkflows();
  }
};

export const resetShareProfileDailyIQandWeeklyAccountsFilter = () => {
  store.dispatch({ type: GET_ANALYTICS_CAMPAIGNS_FILTERS.RESET_CONSTANT_FILTERS });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const reorderCampaignsAndEmails = () => {
  store.dispatch({ type: GET_ANALYTICS_CAMPAIGNS_FILTERS.REORDER_CAMPAIGNS });
  store.dispatch({ type: GET_ANALYTICS_ASSETS_FILTERS.REORDER_ASSETS });
};

export const reorderWorkflows = () => {
  store.dispatch({ type: GET_ANALYTICS_WORKFLOW_LIST.REORDER });
};

export const selectCampaign = (id: any, selectedCampaignsIds?: []) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET,
    payload: id,
  });
  // updateEmailsWithDate(store.getState().analyticsGraph.startDate, store.getState().analyticsGraph.endDate);
};

export const setWorkflowFilter = (filter: any) => {
  store.dispatch({
    type: GET_ANALYTICS_WORKFLOW_FILTERS.SET_FILTERS,
    payload: filter,
  });
};

export const setAssetsFilter = (filter: any) => {
  store.dispatch({
    type: GET_ANALYTICS_ASSETS_FILTERS.SET_FILTERS,
    payload: { selectedFilter: filter, selectedDate: store.getState().analyticsGraph.selectedDatesObject },
  });
};

export const setTestEmailAssetsFilter = () => {
  store.dispatch({
    type: GET_ANALYTICS_ASSETS_FILTERS.SET_TEST_EMAIL_FILTER,
    payload: { selectedDate: store.getState().analyticsGraph.selectedDatesObject },
  });
};

export const resetTestEmailAssetsFilter = () => {
  store.dispatch({
    type: GET_ANALYTICS_ASSETS_FILTERS.RESET_TEST_EMAIL_FILTER,
    payload: { selectedDate: store.getState().analyticsGraph.selectedDatesObject },
  });
};

export const setWorkflowAssetsFilter = (filter: any) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.FILTER_LIST,
    payload: filter,
  });
};
export const selectMultipleAssets = (assets: any) => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET_MULTIPLE,
    payload: { assets },
  });
};

export const selectMultipleAssetsIds = (ids: any[]) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET_SELECTED_ASSETS,
    payload: { ids },
  });
};

export const setEmailDropdownFields = (
  selectAll: boolean,
  unselectAll: boolean,
  searchList: ISearchedEmailDropdownList[],
  selectedAssetsIds: any[],
  excludeAssetsIds: any[],
) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET_EMAIL_DROPDOWN_USING_FILTER_ID,
    payload: {
      selectAll,
      unselectAll,
      searchList,
      selectedAssetsIds,
      excludeAssetsIds,
    },
  });
};

export const unselectMultipleAssets = (assets: any) => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.UNSELECT_MULTIPLE,
    payload: { assets },
  });
};
export const selectAsset = (asset_id: any, campaign_id: any) => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET,
    payload: { asset_id, campaign_id },
  });
};

export const selectWorkflowAsset = (asset_id: any, workflow_id: any) => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.SET,
    payload: { asset_id, workflow_id },
  });
};

export const selectWorkflow = (id: number) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_WORKFLOW.SELECT,
    payload: id,
  });
};

export const setDefaultWorkflow = (workflowId: number) => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_WORKFLOW.SET, payload: workflowId });
  // Applied emails replaced with selected emails when going to Analytics from Workflow Detail Page
  moveSelectedFiltersToApplied();
};

export const resetSelectedWorkflows = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_WORKFLOW.RESET });
};

export const resetAnalyticsWorkflows = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_WORKFLOW.SELECTED_RESET });
};

export const searchAnalyticsDropdownCampaigns = (name: string) => {
  store.dispatch({
    type: ANALYTICS_CAMPAIGNS_SEARCH.SET,
    payload: name,
  });
};

export const searchAnalyticsDropdownAssets = (name: string) => {
  if (name.trim() === '') {
    resetEmailSearch();
  } else {
    store.dispatch({
      type: ANALYTICS_ASSETS_SEARCH.SET,
      payload: name,
    });
  }
};

export const searchAnalyticsDropdownWorkflow = (name: string) => {
  if (name.trim() === '') {
    resetWorkflowSearch();
  } else {
    store.dispatch({
      type: ANALYTICS_WORKFLOWS_SEARCH.SET,
      payload: name,
    });
  }
};

export const analyticsDatesFilterChange = (value: SelectOption) => {
  // let isDefaultStateOfEmails = store.getState().analyticsDashboard.selectedAssetsIds.length === 0;
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES_OBJECT,
    payload: value,
  });

  // if (isDefaultStateOfEmails && value.label === '1 QTR' && value.value === 'qtr')
  //   store.dispatch({
  //     type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES_OBJECT,
  //     payload: value,
  //   });
  let datesObject: any = getDateObject(value.value);

  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES,
    ...datesObject,
  });
  // if (isDefaultStateOfEmails && value.label === '1 QTR' && value.value === 'qtr') {
  //   store.dispatch({
  //     type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES,
  //     ...datesObject,
  //   });
  // }
  // updateEmailsWithDate(datesObject.start_date, datesObject.end_date);
};

export const updateEmailsWithDate = (startDate: string, endDate: string) => {
  const analyticsDashboard = store.getState().analyticsDashboard;
  const filteredAssets = analyticsDashboard.assets.filter((item: IAssetDropdownItem) => {
    const itemDateTime = new Date(item.dateTime);
    const start = new Date(startDate);
    const end = new Date(endDate);
    return (
      itemDateTime >= start &&
      itemDateTime <= new Date(end.setDate(end.getDate() + 1)) &&
      ((analyticsDashboard.isWorkflow &&
        analyticsDashboard.workflows.some(
          (wf: any) =>
            wf.emails.some((email: any) => Number(email.id) === item.id) &&
            analyticsDashboard.selectedWorkflowsIds.includes(wf.id),
        )) ||
        analyticsDashboard.selectedCampaignsIds.includes(item.campaignId))
    );
  });
  selectMultipleAssets(filteredAssets);
};

export const filterAction = (AllCampaignsFilterCheck: boolean, isFilterClicked?: boolean) => {
  let analyticsDashboard = store.getState().analyticsDashboard;
  let analyticsGraph = store.getState().analyticsGraph;
  let { selectedCampaignsIds, selectedAssetsIds } = analyticsDashboard;
  let { startDate, endDate } = analyticsGraph;
  let object: any = {
    allCampaigns: AllCampaignsFilterCheck,
    startDate: startDate,
    endDate: endDate,
  };
  if (selectedCampaignsIds.length > 0) {
    object['campaignIds'] = selectedCampaignsIds;
  }
  if (selectedAssetsIds.length > 0) {
    object['emailIds'] = selectedAssetsIds;
  }
  getAnalyticsFilteredGraphData(object);
  getAnalyticsCardData(object);
  getAnalyticsContentData(object);
};

export const getAnalyticsFilteredGraphData = (params: any) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD,
  });
  const queryWorkflowId = getQueryWorkflowId();
  const isWorkflow = !!queryWorkflowId || store.getState().analyticsDashboard.isWorkflow;
  params.isWorkflow = isWorkflow;

  getAnalyticsGraphDataService({ ...params, analytic_request: '1' })
    .then((res: any) => {
      const serializedData: IGraphData = res.data;
      store.dispatch({
        type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_SUCCESS,
        payload: serializedData,
      });
    })
    .catch((err: any) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_FAIL,
          payload: {},
        });
      }
      // show error alert on frontend
    });
};

export const closeAnalyticsExportPopup = () => {
  store.dispatch({ type: ANALYTICS_DATA_EXPORT.SET_CLOSE });
};

export const resetSelectedCampaigns = (isReset?: boolean) => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.RESET, payload: isReset });
};

export const resetSelectedEmails = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.RESET });
};

export const selectAllCampaigns = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SELECT_ALL });
};

export const unselectAllCampaigns = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.UNSELECT_ALL });
};

export const resetEmailSearch = () => {
  store.dispatch({ type: ANALYTICS_ASSETS_SEARCH.RESET });
  store.dispatch({
    type: GET_ANALYTICS_ASSETS_FILTERS.SET_FILTERS,
    payload: { selectedFilter: {}, selectedDate: store.getState().analyticsGraph.selectedDatesObject },
  });
};

export const resetWorkflowSearch = () => {
  store.dispatch({ type: ANALYTICS_WORKFLOWS_SEARCH.RESET });
};

export const selectAllEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SELECT_ALL,
    payload: { selectedDate: store.getState().analyticsGraph.selectedDatesObject },
  });
};

export const selectAllWorkflowEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.SELECT_ALL,
  });
};

export const unselectAllEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.UNSELECT_ALL,
    payload: { selectedDate: store.getState().analyticsGraph.selectedDatesObject },
  });
};

export const unselectAllWorkflowEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.UNSELECT_ALL,
  });
};

export const updateFirstTimeSearch = () => {
  store.dispatch({
    type: ANALYTICS_ASSETS_SEARCH.SET_FIRST_TIME,
  });
};

export const updateAssetListOnDateFilter = (value: SelectOption) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.DATE_FILTER,
    payload: value,
  });
};

export const updateFilterAssetList = (assets: IAssetDropdownItem[]) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.FILTER_LIST,
    payload: assets,
  });
};

export const resetDashboardCampaignFilters = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD.RESET_CAMPAIGN_FILTERS,
  });
};

export const getDashboardData = (firstRenderDone: boolean, callback?: any) => {
  const isAiEmail = getQueryIsAIEmail();
  const campaignId = getQueryCampaignId().toString();
  const emailId = isAiEmail ? '1' : getQueryEmailId().toString();
  const workflowId = getQueryWorkflowId();
  const fsId = getAnalyticsFilterId();
  const queryEmailIds = getQueryEmailIds();
  const queryAllCampaign = getQueryAllCampaigns() === 'false' ? false : true;
  let analyticsGraph = store.getState().analyticsGraph;
  let analyticsDashboard = store.getState().analyticsDashboard;
  let { startDate, endDate } = analyticsGraph;
  let {
    filterReset,
    campaigns,
    selectedCampaignsIds,
    selectedAssetsIds,
    excludeCampaignsIds,
    excludeAssetsIds,
    appliedCampaignsFilters,
    selectedWorkflowsIds,
    selectAllDropdownEmails,
    unselectAllDropdownEmails,
    searchedEmailList,
  } = analyticsDashboard;
  let stats = store.getState().analyticsGraph.data;
  const { isAllCampaigns, isShareProfile, isDailyIQ, isWeeklyAccountInsights } = appliedCampaignsFilters;

  if (campaignId !== '0' || emailId !== '0') {
    store.dispatch({
      type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES_OBJECT,
      payload: { label: 'All time', value: 'all' },
    });

    let datesObject: any = getDateObject('all');

    store.dispatch({
      type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES,
      ...datesObject,
    });
    // analyticsDatesFilterChange({ label: 'All time', value: 'all' });
    const allTimeDate = getAllTimeDates();
    startDate = allTimeDate.start_date;
    endDate = allTimeDate.end_date;
  }

  let object: any = {
    allCampaigns: campaigns.length === selectedCampaignsIds.length,
    startDate: startDate,
    endDate: endDate,
    selectAll: selectAllDropdownEmails,
    unSelectAll: unselectAllDropdownEmails,
    searchedEmailList: searchedEmailList,
    emailIds: selectedAssetsIds,
    excludeAssetsIds,
    campaignIds: selectedCampaignsIds,
  };

  //Flow for first landing render
  if (
    ((campaignId !== '0' && emailId !== '0') || Object.keys(stats).length === 0 || filterReset === true) &&
    firstRenderDone === false
  ) {
    if (filterReset === true) {
      object = {
        campaignIds: selectedCampaignsIds,
        emailIds: selectedAssetsIds,
        excludeEmailIds: excludeAssetsIds,
        ...object,
        ...(selectedWorkflowsIds?.length > 0
          ? {
              workflowIds: selectedWorkflowsIds,
            }
          : {}),
      };
    } else {
      if (!fsId) {
        if (selectedCampaignsIds.length <= 0 && campaignId !== '0') {
          if (isAiEmail && queryEmailIds.length > 0) {
            queryEmailIds?.forEach((id: any) => {
              selectAsset(parseInt(id), parseInt(campaignId));
            });
          } else {
            selectAsset(parseInt(emailId), parseInt(campaignId));
          }
          moveSelectedFiltersToApplied();
        }
        if (campaignId !== '0') {
          object['campaignIds'] = [campaignId];
          object['allCampaigns'] = false;
        }
        if (emailId !== '0' || queryEmailIds.length) {
          object['emailIds'] = isAiEmail ? queryEmailIds : [emailId];
          object['excludeAssetsIds'] = excludeAssetsIds;
          object['selectAll'] = false;
          object['unSelectAll'] = true;
        }
        if (selectedWorkflowsIds?.length > 0) {
          object['workflowIds'] = selectedWorkflowsIds;
        } else if (workflowId) {
          object['workflowIds'] = [workflowId];
        }
      }
    }

    // check if is share profile || daily IQ || weekly accounts insights
    if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
      let campaign_email_id = getConstantCampaignEmailId({
        isShareProfile,
        isDailyIQ,
        isWeeklyAccountInsights,
      });
      object['campaignIds'] = [campaign_email_id];
      if (!isShareProfile) object['emailIds'] = [campaign_email_id];
    }
    getGraphData(object);
    // getCampaignGraphData(object);
    getAnalyticsCardData(object);
    getAnalyticsContentData(object, callback);
    // getEmailGraphData(object);
  }
};

export const setDefaultFlag = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD.SET_DEFAULT_FLAG });
};

export const setRenderDone = () => {
  store.dispatch({ type: ANALYTICS_CARD_DATA.RENDER_DONE, payload: false });
};

export const getCampaignAndWorkflowDropdownData = () => {
  store.dispatch({
    type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.CAMPAIGN_AND_WORKFLOW_LOAD,
  });
  getCampaignAndWorkflowDropdownService()
    .then((res: any) => {
      if (res.status === 200) {
        const { total_count: total_campaigns_count, data: campaigns } = res.data.campaigns;
        const { total_count: total_workflows_count, data: workflows } = res.data.workflows;
        store.dispatch({
          type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.CAMPAIGN_AND_WORKFLOW_SUCCESS,
          payload: {
            totalCampaigns: total_campaigns_count,
            campaigns: serializeAnalyticsFiltersDropdownCampaigns(campaigns),
            totalWorkflows: total_workflows_count,
            workflows: serializeAnalyticsWorkflow(workflows),
          },
        });
        const queryCampaignId = getQueryCampaignId();
        const queryEmailId = getQueryEmailId();
        const isAIEmail = getQueryIsAIEmail();
        const queryEmailIds = getQueryEmailIds();
        const queryWorkflowId = getQueryWorkflowId();
        const analyticsFilterId = getAnalyticsFilterId();
        if (analyticsFilterId) {
          applyFiltersFromLocalStorage(JSON.parse(localStorage.getItem('analyticsFiltersWithId') || ''));
        } else {
          if (queryCampaignId) {
            if (queryCampaignId === 1 || queryCampaignId === 5) {
              setShareProfileFilter(true);
              store.dispatch({
                type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
              });
            } else {
              selectCampaign(queryCampaignId);
            }
            reorderCampaignsAndEmails();
          } else if (!queryWorkflowId) {
            selectAllCampaigns();
          }
          if (queryEmailId || isAIEmail) {
            setEmailDropdownFields(false, true, [], isAIEmail ? queryEmailIds : [queryEmailId], []);
          }
        }
        moveSelectedFiltersToApplied();
      }
    })
    .catch((err: any) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.CAMPAIGN_AND_WORKFLOW_FAIL,
        });
      }
    });
};

export const resetDropdownCampaignsAndWorkflows = () => {
  store.dispatch({
    type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.RESET_CAMPAIGNS_AND_WORKFLOWS,
  });
};

export const getEmailDropdownData = (params: any, firstTime?: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_LOAD,
  });
  getEmailDropdownService(params)
    .then((res: any) => {
      if (res.status === 200) {
        const { total_count, data, marked_count } = res.data.emails;
        store.dispatch({
          type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_SUCCESS,
          payload: {
            total: total_count,
            emails: serializeDropdownEmails(data),
            offset: params.offset,
            emailSearchTerm: params?.emailSearchTerm ?? '',
            markedCount: marked_count,
            isWorkflow: Boolean(params.workflowId),
            searchMarkedCount: params.searchMarkedCount ?? 0,
          },
        });
        if (firstTime) {
          moveSelectedFiltersToApplied();
        }
      }
    })
    .catch((err: any) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_FAIL,
        });
      }
    });
};

export const resetDropdownEmails = () => {
  store.dispatch({
    type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.EMAIL_RESET,
  });
};

export const resetSearchDropdownEmails = () => {
  store.dispatch({
    type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.SEARCH_EMAIL_RESET,
  });
};

export const setDropdownEmailMarkedCount = (value: number) => {
  store.dispatch({
    type: GET_ANALYTICS_FILTERS_DROPDOWN_DATA.SET_EMAIL_MARKED_COUNT,
    payload: value,
  });
};
